const config = {
    rootUrl: "http://estateviden-staging.dk/"
}

export default config;
